/* eslint-disable @typescript-eslint/no-var-requires */
import phoenixResortsCarousel from './lib/phoenixResortsCarousel.graphql';
import phoenixLeisureDestinationPropertiesByGeolocation from './lib/phoenixLeisureDestinationPropertiesByGeolocation.graphql';
import phoenixLeisureDestinationPropertiesByLocation from './lib/phoenixLeisureDestinationPropertiesByLocation.graphql';
import PhoenixSearchPropertiesByArea from './lib/PhoenixSearchPropertiesByArea.graphql';
import phoenixStorefrontDestinationProperties from './lib/PhoenixSearchPropertiesByGeolocation.graphql';

export {
  phoenixResortsCarousel,
  phoenixLeisureDestinationPropertiesByGeolocation,
  phoenixLeisureDestinationPropertiesByLocation,
  PhoenixSearchPropertiesByArea,
  phoenixStorefrontDestinationProperties,
};
